module.exports = __webpack_public_path__ + "img/down-yn3.c0edf0ef.png";